/** Color should not be used (barely) directly in applications,
 *  always use the VelocityTheme.
 *  It's here for exceptional usage or other usages than web applications
 * */
export var Color;
(function (Color) {
    Color["aquaBlue"] = "#00B1AF";
    Color["aquaBlue20"] = "#CCEFEF";
    Color["aquaBlue40"] = "#99E0DF";
    Color["aquaBlue60"] = "#66D0CF";
    Color["aquaBlue80"] = "#33C1BF";
    Color["black"] = "#000000";
    Color["bloodOrange"] = "#EE4C14";
    Color["error"] = "#E7401E";
    Color["error40"] = "#FAD9D2";
    Color["freshGreen"] = "#A9C90E";
    Color["freshGreen20"] = "#EEF4CF";
    Color["freshGreen40"] = "#DDE99F";
    Color["freshGreen60"] = "#CBDF6E";
    Color["freshGreen80"] = "#BAD43E";
    Color["gallery"] = "#EEEEEE";
    Color["grassGreen"] = "#009A17";
    Color["grassGreen20"] = "#CCEBD1";
    Color["grassGreen40"] = "#99D7A2";
    Color["grassGreen60"] = "#66C274";
    Color["grassGreen80"] = "#33AE45";
    Color["lightOrange"] = "#ED8B00";
    Color["midOrange"] = "#F06400";
    Color["mist"] = "#F6F8FB";
    Color["petrolBlue"] = "#004A5D";
    Color["petrolBlue20"] = "#CCDBDF";
    Color["petrolBlue40"] = "#99B7BE";
    Color["petrolBlue60"] = "#66929E";
    Color["petrolBlue80"] = "#336E7D";
    Color["sand"] = "#F6F6F6";
    Color["steel"] = "#545656";
    Color["steel20"] = "#DDDDDD";
    Color["steel40"] = "#BBBBBB";
    Color["steel60"] = "#989A9A";
    Color["steel80"] = "#767878";
    Color["thunder"] = "#2D2D2D";
    Color["white"] = "#FFFFFF";
})(Color || (Color = {}));
//# sourceMappingURL=Color.js.map